// extracted by mini-css-extract-plugin
export default {"bubblesview":"bubblesview_a1be0d4b9fa0448bec85","bubble":"bubble_c905a67d04e2a351bca2"};